export enum MyProfileCardType {
  EXPLORE = "explore",
  SERVICE = "service",
  VALUATION = "valuation",
} 